{
  "dataFieldsInTooltip": {
    "title": "Etiqueta Object Hover",
    "tooltip": "Elige hasta 5 valores de atributo para mostrarlos al pasar el ratón por encima de un objeto del mapa.",
    "tooltipAttributeTypes": "Los tipos de atributos admitidos son: texto, número, lista y What3Words",
    "error": "Algo ha ido mal. Ponte en contacto con el servicio de asistencia si el problema continúa"
  },
  "tooltipShortcuts": {
    "select_object": "Presiona V",
    "draw": "Presiona D",
    "measure": "Presiona M",
    "undo": "Ctrl + Z",
    "redo": "Ctrl + Mayús + Z",
    "comment": "Presiona C",
    "copy_paste": "Ctrl + C/Ctrl + V",
    "delete_object": "Presiona Del",
    "cancel_drawing": "Pulse Esc o haga clic con el botón derecho",
    "confirm_drawing": "Presiona Entrar o haz doble clic"
  },
  "draw": {
    "polygon": "Polígono",
    "line": "Línea",
    "rectangle": "Rectángulo",
    "routePlanner": "Planificador de rutas",
    "point": "¿Punto",
    "model": "Modelo",
    "icon": "Icono"
  },
  "select": {
    "select_object": "Seleccione un objeto",
    "select_area": "Seleccione objetos dentro del área"
  },
  "drawRoute": "Dibuja la ruta",
  "drawLineRectangle": "Dibuja un rectángulo lineal",
  "layerOptionsTooltips": {
    "lock_layer": "Bloquear capa",
    "unlock_layer": "Desbloquea la capa",
    "cannot_lock_layer_while_editing": "No puede bloquear una capa mientras la está editando"
  },
  "sitemapVersion": {
    "perimeter": "Perímetro",
    "drawOutsideCADPerimeter": "No se puede dibujar fuera del límite en este nivel"
  },
  "map_objects": "mapear objetos",
  "map_object": "objeto de mapa",
  "plan": "planear",
  "map_layer": "capas de mapa",
  "layers": "capas",
  "layer": "capa",
  "layer_data_field": "campo de datos de capa",
  "layer_geoJson": "capa como GeoJSON",
  "route_waypoints": "puntos de referencia de ruta",
  "map_objects_attribute_values": "valores de atributos de objetos de mapa",
  "saved_map_view": "vista de mapa guardada",
  "map_object_geometry": "geometría del objeto del mapa",
  "map_background": "fondo del mapa",
  "map_sidebar_order": "orden de barra lateral del mapa",
  "map_comment": "comentario del mapa",
  "model": "modelo",
  "snapping": {
    "snapToDraw": "Ajustar al objeto"
  },
  "drawMapObjectTooltip": "Haga clic para añadir otro objeto a esta capa",
  "exports2": {
    "title": "Título",
    "imageUpload": {
      "title": "Logotipo personalizado"
    }
  },
  "digitalTwin": {
    "occupiedTable": {
      "id": "ID de servidor",
      "status": "Estado",
      "user": "Usuario"
    },
    "status": {
      "Occupied": "En uso",
      "Available": "Disponible",
      "Starting": "Empezando",
      "Stopped": "Detenido",
      "Error": "Error"
    },
    "occupiedPopup": {
      "header": "Todos los servidores gemelos digitales no están disponibles en este momento",
      "message": "Vuelve a intentarlo más tarde o ponte en contacto con {{ supportEmail }} para obtener más información"
    }
  },
  "fileUpload": {
    "invalid_compression_size": "El archivo que estás intentando subir es demasiado grande y no se ha podido comprimir."
  }
}